<template>
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-black bg-opacity-50 p-4 sm:p-6">
      <div class="relative w-full max-w-md rounded-lg bg-white shadow-xl ring-1 ring-gray-200">
        
        <!-- Header -->
        <div class="flex items-center justify-between border-b px-4 py-3 bg-gray-50 rounded-t-lg">
          <h3 class="text-lg font-medium text-gray-900">
            Envoyer un e-mail
          </h3>
          <button @click="close" class="text-gray-400 hover:text-gray-500 focus:outline-none">
            <span class="sr-only">Fermer</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Body -->
        <div class="p-6 space-y-4">
          <div v-if="client">
            <p class="text-sm text-gray-600 mb-2">Destinataire : <span class="font-semibold">{{ client.Nom }}</span> ({{ client.Email_Gologin }})</p>
            
            <label class="block text-sm font-medium text-gray-700 mb-1">Modèle d'e-mail</label>
            <select v-model="emailType" class="w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm p-2 border">
              <option value="presentation">Présentation espace client – FR</option>
              <option value="presentation_en">Presentation client portal – EN</option>
              <option value="onboarding">Onboarding – FR</option>
              <option value="onboarding_en">Onboarding – EN</option>
              <option value="bonnespratiques">Bonnes pratiques – FR</option>
              <option value="bonnespratiques_en">Best practices – EN</option>
            </select>
          </div>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-end gap-3 border-t bg-gray-50 px-4 py-3 rounded-b-lg">
          <button
            type="button"
            class="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            @click="close"
            :disabled="loading"
          >
            Annuler
          </button>
          <button
            type="button"
            class="inline-flex justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            :class="{ 'opacity-75 cursor-wait': loading }"
            @click="sendEmail"
            :disabled="loading"
          >
            <span v-if="loading" class="mr-2">⏳</span>
            {{ loading ? 'Envoi...' : 'Envoyer' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from '../../plugins/axios';

export default {
  name: 'EmailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    client: {
      type: Object,
      default: null
    }
  },
  emits: ['close', 'success'],
  data() {
    return {
      emailType: 'presentation',
      loading: false
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // Reset state on open
        this.emailType = 'presentation';
      }
    }
  },
  methods: {
    close() {
      if (!this.loading) {
        this.$emit('close');
      }
    },
    async sendEmail() {
      if (!this.client) return;

      this.loading = true;
      try {
        const [ type, langSuffix ] = this.emailType.split('_');
        const payload = {
          email: this.client.Email_Gologin,
          firstname: this.client.Nom,
          langue: langSuffix === 'en' ? 'en' : 'fr',
          type
        };

        const response = await axios.post('/admin2/email/launch', payload);
        
        if (response.data && !response.data.error) {
          this.$emit('success', 'E-mail envoyé avec succès !');
          this.close();
        } else {
          alert(response.data.error || 'Une erreur est survenue.');
        }
      } catch (err) {
        console.error('Erreur envoi e-mail :', err);
        alert(`Erreur : ${err.message}`);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

